(function() {
	function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}

	function clamp(num, min, max){return Math.min(Math.max(num, min), max)}

	ready(function(){
		var grid = document.querySelector('[data-bundle-grid]');
		if(!grid) return;
		var section = grid.getAttribute('data-section-id');
		var counterEl = document.querySelector('[data-bundle-counter]');
		var limit = counterEl ? parseInt(counterEl.getAttribute('data-limit'), 10) : 30;
		var addedEl = counterEl ? counterEl.querySelector('[data-added]') : null;
		var remainingEl = counterEl ? counterEl.querySelector('[data-remaining]') : null;
		var addBtn = document.querySelector('[data-add-bundle]');
		var searchInput = document.querySelector('[data-bundle-search]');
		var loadMoreBtn = document.querySelector('[data-load-more]');

		var quantitiesByVariant = {};
		var total = 0;
		var bar = document.querySelector('[data-bundle-bar]');
		var barList = document.querySelector('[data-bundle-list]');
		var barHandle = document.querySelector('[data-bundle-bar-handle]');
		var isBarOpen = false;
		var barHeightCollapsed = 64; // px
		var barHeightExpanded = Math.max(320, Math.min(Math.round(window.innerHeight * 0.6), 540));
        var toggleBtn = document.querySelector('[data-bundle-bar-toggle]');

		function renderBarList(){
			if(!bar || !barList) return;
			var entries = Object.keys(quantitiesByVariant).map(function(vid){
				var qty = parseInt(quantitiesByVariant[vid]||'0',10)||0;
				if(qty <= 0) return null;
				var card = grid.querySelector('[data-variant-id="'+vid+'"]');
				var productCard = card ? card.closest('[data-product-card]') : null;
				var title = productCard ? (productCard.getAttribute('data-title')||'') : 'Item';
				var img = productCard ? productCard.querySelector('img') : null;
				var src = img ? img.currentSrc || img.src : '';
				return { id: vid, title: title, qty: qty, src: src };
			}).filter(Boolean);
			if(!entries.length){
				bar.setAttribute('aria-hidden','true');
				bar.style.transform = 'translateY(100%)';
				isBarOpen = false;
				barList.innerHTML = '';
				return;
			}
			var html = entries.map(function(e){
				return '\n<div class="bundle-bar-item" data-bar-item data-variant-id="'+e.id+'">\n\t<div class="item-media">'+ (e.src?'<img src="'+e.src+'" alt="">':'') +'</div>\n\t<div class="item-info">\n\t\t<div class="item-title">'+e.title+'</div>\n\t\t<div class="item-qty">Qty: '+e.qty+'</div>\n\t</div>\n\t<div class="item-actions">\n\t\t<button class="quantity-button" type="button" data-decrease>−</button>\n\t\t<button class="quantity-button" type="button" data-increase>+</button>\n\t</div>\n</div>';
			}).join('');
			barList.innerHTML = html;
			bar.removeAttribute('aria-hidden');
			openBar(false);
		}

		function openBar(expand){
			if(!bar) return;
			bar.style.transform = 'translateY(0)';
			bar.style.height = (expand ? barHeightExpanded : barHeightCollapsed) + 'px';
			isBarOpen = true;
            if(toggleBtn){ toggleBtn.setAttribute('aria-expanded', expand ? 'true' : 'false'); toggleBtn.classList.toggle('expanded', !!expand); }
		}

		function toggleBar(){
			if(!bar) return;
			if(!isBarOpen){
				openBar(false);
			} else {
				// toggle collapsed/expanded
				var current = parseInt(bar.style.height||barHeightCollapsed,10);
				bar.style.height = (current <= barHeightCollapsed ? barHeightExpanded : barHeightCollapsed) + 'px';
                var expand = current <= barHeightCollapsed;
				bar.style.height = (expand ? barHeightExpanded : barHeightCollapsed) + 'px';
				if(toggleBtn){ toggleBtn.setAttribute('aria-expanded', expand ? 'true' : 'false'); toggleBtn.classList.toggle('expanded', expand); }
			}
		}

		function attachBarGestures(){
			if(!bar || !barHandle) return;
			var startY = 0; var startH = 0; var dragging = false;
			var onStart = function(y){ dragging = true; startY = y; startH = parseInt(bar.style.height||barHeightCollapsed,10) || barHeightCollapsed; bar.classList.add('dragging'); };
			var onMove = function(y){ if(!dragging) return; var dy = startY - y; var nextH = startH + dy; nextH = Math.max(barHeightCollapsed, Math.min(nextH, Math.max(barHeightExpanded, 260))); bar.style.height = nextH + 'px'; };
			var onEnd = function(){ if(!dragging) return; dragging = false; bar.classList.remove('dragging'); var current = parseInt(bar.style.height||barHeightCollapsed,10); bar.style.height = (current > (barHeightCollapsed + 80) ? barHeightExpanded : barHeightCollapsed) + 'px'; };
			barHandle.addEventListener('click', toggleBar);
			barHandle.addEventListener('mousedown', function(e){ onStart(e.clientY); e.preventDefault(); });
			window.addEventListener('mousemove', function(e){ onMove(e.clientY); });
			window.addEventListener('mouseup', onEnd);
			barHandle.addEventListener('touchstart', function(e){ var t=e.touches[0]; onStart(t.clientY); }, {passive:true});
			window.addEventListener('touchmove', function(e){ if(!dragging) return; var t=e.touches[0]; onMove(t.clientY); }, {passive:true});
			window.addEventListener('touchend', onEnd);
		}

        if(toggleBtn){ toggleBtn.addEventListener('click', toggleBar); }

		function updateCounter(){
			// Update all counters (header + bar)
			document.querySelectorAll('[data-added]').forEach(function(el){ el.textContent = String(total); });
			document.querySelectorAll('[data-remaining]').forEach(function(el){ el.textContent = String(Math.max(0, limit - total)); });
			if(addBtn){
				addBtn.disabled = total !== limit;
				addBtn.classList.toggle('is-disabled', addBtn.disabled);
			}
			renderBarList();
		}

		function setQty(input, nextVal){
			var wrap = input.closest('[data-variant-id]');
			if(!wrap) return;
			var variantId = wrap.getAttribute('data-variant-id');
			var current = parseInt(input.value || '0', 10) || 0;
			var delta = nextVal - current;
			var remaining = Math.max(0, limit - total);
			if(delta > remaining){
				nextVal = current + remaining;
				delta = nextVal - current;
			}
			nextVal = Math.max(0, nextVal);
			input.value = String(nextVal);
			quantitiesByVariant[variantId] = nextVal;
			total = Object.values(quantitiesByVariant).reduce(function(s,v){return s + (parseInt(v||'0',10)||0)}, 0);
			updateCounter();
		}

		function relocateQuantityControls(root) {
			var scope = root || document;
			scope.querySelectorAll('.bundle-qty').forEach(function(qty) {
				var productCard = qty.closest('[data-product-card]');
				if (!productCard) return;

				// Try to find .quick-add inside this product card (matches placement in the HTML sample)
				var quickAdd = productCard.querySelector('.quick-add-qty, .quick-add');
				if (quickAdd && qty.parentElement !== quickAdd) {
					// Remove the qty from its current parent before appending (to avoid duplicate elements)
					quickAdd.appendChild(qty);
					return;
				}

				// Fallback: try to place at the top of the main .card-content.info
				var infos = productCard.querySelectorAll('.card-content.info');
				if (infos.length) {
					var info = infos[infos.length-1]; // Use the last .info; matches Shopify structure
					if (qty.parentElement !== info) {
						info.insertBefore(qty, info.firstChild);
					}
				}
			});
		}

		// Prevent QuantityInput component from handling bundle quantity buttons
		// by stopping propagation before it reaches the component's handlers
		grid.addEventListener('click', function(e){
			// Only process if click is within bundle quantity controls
			var button = e.target.closest('[data-decrease], [data-increase]');
			if(!button) return;
			
			// Ensure the button is within our bundle grid (not a form or other element)
			if(!grid.contains(button)) return;
			
			var wrap = button.closest('.bundle-qty');
			if(!wrap || wrap.hasAttribute('data-unavailable')) return;
			
			// Double-check it's within our grid
			if(wrap.closest('[data-bundle-grid]') !== grid) return;
			
			// Don't interfere with form elements or other interactive elements
			if(e.target.closest('form') && !wrap.closest('form')) return;
			
			// Stop immediate propagation to prevent QuantityInput component handler
			e.stopImmediatePropagation();
			e.preventDefault();
			
			var input = wrap.querySelector('[data-qty]');
			if(!input) return;
			
			var dec = e.target.closest('[data-decrease]');
			var current = parseInt(input.value||'0',10)||0;
			var next = dec ? Math.max(0, current - 1) : current + 1;
			setQty(input, next);
		}, true); // Use capture phase to run before QuantityInput component handlers

		grid.addEventListener('change', function(e){
			var input = e.target.matches('[data-qty]') ? e.target : null;
			if(!input) return;
			var val = parseInt(input.value||'0',10)||0;
			setQty(input, val);
		});

        var resetBtn = document.querySelector('[data-bundle-search-reset]');
		
		function toggleResetButton() {
			if (!resetBtn || !searchInput) return;
			if (searchInput.value.trim() === '') {
				resetBtn.classList.add('hidden');
			} else {
				resetBtn.classList.remove('hidden');
			}
		}
		
		function clearSearch() {
			if (!searchInput) return;
			searchInput.value = '';
			searchInput.focus();
			toggleResetButton();
			if (grid) {
				grid.querySelectorAll('[data-product-card]').forEach(function(card) {
					card.style.display = '';
				});
			}
		}

		if(searchInput){
			searchInput.addEventListener('input', function(){
				var q = searchInput.value.trim().toLowerCase();
				toggleResetButton();
				grid.querySelectorAll('[data-product-card]').forEach(function(card){
					var title = (card.getAttribute('data-title')||'').toLowerCase();
					card.style.display = title.indexOf(q) !== -1 ? '' : 'none';
				});
			});
		}

        if (resetBtn) {
			resetBtn.addEventListener('click', function(e) {
				e.preventDefault();
				clearSearch();
			});
		}

        // Sticky search: toggle visual class when pinned
		var searchWrap = document.querySelector('.bundle-search');
		function updateStickyState(){
			if(!searchWrap) return;
			var rect = searchWrap.getBoundingClientRect();
			var stuck = rect.top <= (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bundle-sticky-top')) || 0);
			searchWrap.classList.toggle('is-sticky', stuck);
		}
		window.addEventListener('scroll', updateStickyState, {passive:true});
		window.addEventListener('resize', updateStickyState);
		updateStickyState();

		if(loadMoreBtn){
			loadMoreBtn.addEventListener('click', function(){
				var nextUrl = loadMoreBtn.getAttribute('data-next-url');
				if(!nextUrl) return;
				loadMoreBtn.disabled = true;
				fetch(nextUrl, {credentials:'same-origin'}).then(function(r){return r.text()}).then(function(html){
					var tmp = document.createElement('div');
					tmp.innerHTML = html;
					var nextGrid = tmp.querySelector('[data-bundle-grid]');
					if(nextGrid){
						nextGrid.querySelectorAll('[data-product-card]').forEach(function(li){
							grid.appendChild(li);
						});
						// Relocate quantity controls for newly appended cards
						relocateQuantityControls(grid);
					}
					var nextPagButton = tmp.querySelector('[data-load-more]');
					if(nextPagButton && nextPagButton.getAttribute('data-next-url')){
						loadMoreBtn.setAttribute('data-next-url', nextPagButton.getAttribute('data-next-url'));
						loadMoreBtn.disabled = false;
					} else {
						loadMoreBtn.remove();
					}
				}).catch(function(){ loadMoreBtn.disabled = false; });
			});
		}

		if(addBtn){
			var originalBtnText = addBtn.textContent || addBtn.innerText || 'Add bundle to cart';
			addBtn.addEventListener('click', function(e){
				e.preventDefault();
				if(total !== limit) {
					alert('Please select exactly ' + limit + ' items before adding to cart.');
					return;
				}
				// Get bundle variant id from button dataset
				var bundleVariantId = addBtn.getAttribute('data-bundle-variant-id');
				
				if(!bundleVariantId || bundleVariantId === 'null' || bundleVariantId === 'undefined' || (typeof bundleVariantId === 'string' && bundleVariantId.trim() === '')){ 
					addBtn.disabled = false;
					if(addBtn.querySelector('span')) {
						addBtn.querySelector('span').textContent = originalBtnText;
					} else {
						addBtn.textContent = originalBtnText;
					}
					return; 
				}
				// Build human-readable summary and a compact JSON selection
				var selectionArray = [];
				Object.keys(quantitiesByVariant).forEach(function(variantId){
					var qty = parseInt(quantitiesByVariant[variantId]||'0',10)||0;
					if(qty <= 0) return;
					var card = grid.querySelector('[data-variant-id="'+variantId+'"]');
					var productCard = card ? card.closest('[data-product-card]') : null;
					var title = productCard ? (productCard.getAttribute('data-title')||'') : ('Variant '+variantId);
					selectionArray.push({ id: Number(variantId), title: title, qty: qty });
				});
				if(!selectionArray.length) {
					alert('Please select at least one item.');
					return;
				}
				var summaryLines = selectionArray.map(function(e){ return e.title + ' x' + e.qty; });
				var properties = {
					'Bundle contents': summaryLines.join(' and '),
					'Bundle items count': String(total)
				};
				addBtn.disabled = true;
				if(addBtn.querySelector('span')) {
					addBtn.querySelector('span').textContent = 'Adding...';
				} else {
					addBtn.textContent = 'Adding...';
				}
				
				// Validate variant ID
				var variantIdNum = Number(bundleVariantId);
				if(!variantIdNum || isNaN(variantIdNum) || variantIdNum <= 0) {
					addBtn.disabled = false;
					if(addBtn.querySelector('span')) {
						addBtn.querySelector('span').textContent = originalBtnText;
					} else {
						addBtn.textContent = originalBtnText;
					}
					return;
				}
				
				// Use proper routes and fetchConfig if available
				var cartUrl = (typeof window.routes !== 'undefined' && window.routes.cart_add_url) 
					? window.routes.cart_add_url 
					: '/cart/add.js';
				
				// Check for Recharge subscription selection (selling_plan passed to cart when selected)
				var subscriptionEl = document.querySelector('[data-bundle-subscription]');
				var selectedPlanInput = subscriptionEl ? subscriptionEl.querySelector('input[name="bundle-purchase-type"]:checked') : null;
				var sellingPlanId = (selectedPlanInput && selectedPlanInput.value) ? String(selectedPlanInput.value).trim() : '';

				// Prepare cart item - include selling_plan when subscription selected
				var cartItem = { id: variantIdNum, quantity: 1, properties: properties };
				if (sellingPlanId) {
					cartItem.selling_plan = parseInt(sellingPlanId, 10);
				}

				var cartData = {
					items: [ cartItem ]
				};
				
				var config = {
					method: 'POST',
					headers: { 
						'Content-Type': 'application/json', 
						'Accept': 'application/json'
					},
					body: JSON.stringify(cartData)
				};
				
				// Use fetchConfig helper if available
				if(typeof fetchConfig !== 'undefined') {
					var baseConfig = fetchConfig('json');
					config.headers = Object.assign({}, baseConfig.headers, config.headers);
				}
				
				fetch(cartUrl, config)
					.then(function(response){
						// Check if response is ok
						if(!response.ok) {
							// Try to parse as JSON, but handle non-JSON responses
							return response.text().then(function(text){
								var error;
								try {
									error = JSON.parse(text);
								} catch(e) {
									error = { message: text || 'HTTP ' + response.status + ' ' + response.statusText };
								}
								throw error;
							});
						}
						// Try to parse as JSON
						return response.text().then(function(text){
							try {
								return JSON.parse(text);
							} catch(e) {
								// If not JSON, might be HTML or empty
								if(text.trim() === '') {
									return { success: true };
								}
								throw new Error('Invalid response format from server');
							}
						});
					})
					.then(function(data){
						
						// Check for Shopify error format
						if(data.status) {
							var errorMsg = data.description || data.message || 'Failed to add to cart';
							throw new Error(errorMsg);
						}
						
						// Check for errors array
						if(data.errors && data.errors.length > 0) {
							var errorMsg = Array.isArray(data.errors) ? data.errors.join(', ') : data.errors;
							throw new Error(errorMsg);
						}
						
						// Check for error property
						if(data.error) {
							throw new Error(data.error);
						}
						
						// Success - trigger cart update event if cart drawer exists
						if(typeof window.dispatchEvent !== 'undefined') {
							window.dispatchEvent(new CustomEvent('cart:updated'));
						}
						
						// Redirect to cart
						window.location.href = (typeof window.routes !== 'undefined' && window.routes.cart_url) 
							? window.routes.cart_url 
							: '/cart';
					})
					.catch(function(error){
						var errorMsg = 'Failed to add bundle to cart. ';
						
						// Try to extract meaningful error message
						if(error.description) {
							errorMsg += error.description;
						} else if(error.message) {
							errorMsg += error.message;
						} else if(typeof error === 'string') {
							errorMsg += error;
						} else if(error.errors && Array.isArray(error.errors)) {
							errorMsg += error.errors.join(', ');
						} else if(error.errors && typeof error.errors === 'string') {
							errorMsg += error.errors;
						} else {
							errorMsg += 'Please check the console for details and try again.';
						}
						
						alert(errorMsg);
						addBtn.disabled = false;
						if(addBtn.querySelector('span')) {
							addBtn.querySelector('span').textContent = originalBtnText;
						} else {
							addBtn.textContent = originalBtnText;
						}
					});
			});
		}

		// Delegate clicks within bottom bar list to adjust quantities
		if(barList){
			barList.addEventListener('click', function(e){
				var dec = e.target.closest('[data-decrease]');
				var inc = e.target.closest('[data-increase]');
				if(!dec && !inc) return;
				var item = e.target.closest('[data-bar-item]');
				if(!item) return;

                // Prevent the native quantity-input component from handling this click
				e.preventDefault();
				e.stopPropagation();

				var variantId = item.getAttribute('data-variant-id');
				var wrap = grid.querySelector('[data-variant-id="'+variantId+'"]');
				if(!wrap) return;
				var input = wrap.querySelector('[data-qty]');
				var current = parseInt(input.value||'0',10)||0;
				var next = dec ? Math.max(0, current - 1) : current + 1;
				setQty(input, next);
			});
		}

		attachBarGestures();
		relocateQuantityControls();
		window.addEventListener('resize', function(){
			barHeightExpanded = Math.max(320, Math.min(Math.round(window.innerHeight * 0.6), 540));
			if(bar && isBarOpen){
				var current = parseInt(bar.style.height||barHeightCollapsed,10);
				if(current > barHeightCollapsed){ bar.style.height = barHeightExpanded + 'px'; }
			}
		});
		updateCounter();
	});
})();


